<script setup lang="ts">
import type { TagsInputInputProps } from 'radix-vue'
import type { HTMLAttributes } from 'vue'
import { TagsInputInput, useForwardProps } from 'radix-vue'
import { computed } from 'vue'
import { cn } from '~/helpers'

const props = defineProps<TagsInputInputProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <TagsInputInput v-bind="forwardedProps" :class="cn('placeholder:text-[#A8B6D8] min-h-6 focus:outline-none flex-1 bg-transparent px-1', props.class)" />
</template>
